<template>
  <div v-if="scheduledList.length" class="column content-box">
    <woot-modal-header
      :header-title="$t('SCHEDULED_MESSAGE.EDIT.TITLE')"
      :header-content="$t('SCHEDULED_MESSAGE.EDIT.DESCRIPTION')"
    />

    <form
      v-for="scheduled in scheduledList"
      :key="scheduled.id"
      class="card-wrapper"
      @submit.prevent="$emit('on-delete-click', scheduled)"
    >
      <div class="card-box">
        <div class="card-box-content">
          <h2>{{ $t('SCHEDULED_MESSAGE.EDIT.FORM.SCHEDULED_AT') }}</h2>
          <p class="strong">
            {{ formatDate(scheduled.scheduled_at) }}
          </p>
        </div>

        <div class="card-box-content">
          <h2>{{ $t('SCHEDULED_MESSAGE.EDIT.FORM.TEMPLATE') }}</h2>
          <p class="strong" v-html="scheduled.content" />
        </div>

        <div class="card-box-content">
          <h2>{{ $t('SCHEDULED_MESSAGE.EDIT.FORM.CANCELLATION') }}</h2>
          <div>
            <fluent-icon
              :icon="getIcon(scheduled).name"
              :class="getIcon(scheduled).classname"
              v-tooltip="getIcon(scheduled).tooltip"
              size="26"
            />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <woot-button size="small" variant="smooth" color-scheme="alert">
          {{ $t('SCHEDULED_MESSAGE.EDIT.CANCEL_BUTTON_TEXT') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  props: {
    scheduledList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy - HH:mm');
    },
    getIcon(scheduled) {
      let name = 'dismiss-circle';
      let classname = 'icon-dismiss';
      let tooltip = this.$t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.DISABLED');

      if (scheduled.enable_cancellation) {
        name = 'checkmark-circle';
        classname = 'icon-check';
        tooltip = this.$t('INBOX_MGMT.PRE_CHAT_FORM.ENABLE.OPTIONS.ENABLED');
      }

      return { name, classname, tooltip };
    },
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  padding: var(--space-one);
  background-color: var(--b-50);
  border-radius: var(--border-radius-medium);

  .card-box-content {
    margin-bottom: var(--space-two);

    h2 {
      font-size: var(--font-size-small);
      color: var(--b-800);
    }

    p {
      font-size: var(--font-size-small);
      font-weight: var(--font-weight-normal);
      color: var(--b-700);
    }

    .icon-dismiss {
      color: var(--r-800);
    }

    .icon-check {
      color: var(--g-800);
    }
  }
}

.modal-footer {
  width: 100%;
  justify-content: center !important;
}
</style>